import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
// import * as serviceworker from './serviceWorker'

import App from "./App";

// ✅ Estilos globales para eliminar scroll innecesario del body/html
const globalStyles = `
  html, body {
    height: 100%;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
  #root {
    height: 100%;
    overflow: hidden;
  }
`;

// ✅ Inyectar estilos globales
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = globalStyles;
document.head.appendChild(styleSheet);

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

// serviceworker.register()